// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3Efst","text":"SelectPayment_text__2wbTH","title":"SelectPayment_title__1FJ-T","btn":"SelectPayment_btn__2Wr1J"};